<template>
    <tr>
        <th>
           <!-- <TableSelectCheckbox checkboxId="bulkSelectAll" /> -->
        </th>

        <th>
            <TableHeadSortable :label="$t('modules.evaluations.index.evalsList.tableHeadLabel1')" :isActive="sortName == 'candidate_username'" sortId="candidate_username" @sortChanged="handleSortByName"/>
        </th>
        <th>
            <TableHeadSortable :label="$t('modules.evaluations.index.evalsList.tableHeadLabel2')" :isActive="sortName == 'sight_groups.name'" sortId="sight_groups.name" @sortChanged="handleSortByName"/>
        </th>
        <th>
            {{ $t('modules.evaluations.index.evalsList.tableHeadLabel3') }}
        </th>
        <th>
            <TableHeadSortable :label="$t('modules.evaluations.index.evalsList.tableHeadLabel4')" :isActive="sortName == 'created_at'" sortId="created_at" @sortChanged="handleSortByName"/>
        </th>

        <th class="icon_td"></th>
    </tr>

</template>

<script>
export default {
    name: 'TableEvalsHead',
    components: {},
    data(){
        return {
            sortName: null,
            sortType: "asc",
            inFavoriteSort: false
        }
    },
    computed: {},
    methods: {
        handleSortByName(sortType, sortId){
            this.inFavoriteSort = false
            this.sortType = sortType
            this.sortName = sortId
            this.$emit('onSort', this.sortName, this.sortType)
        },
        ToggleSortFavorite(){
            this.inFavoriteSort = true
            this.sortType = 'desc'
            this.sortName = 'is_favorite'
            this.$emit('onSort', this.sortName, this.sortType)
        }
    }
}
</script>
